// Sentinel for "no selection" in Shadcn Select (empty string is disallowed)
export const NONE = "__none__";
export const toSelectValue = (v) => (v ? v : NONE);
export const fromSelectValue = (v) => (v === NONE ? "" : v);
